/**
 * Single place that knows how the admin session is persisted in the browser.
 */

export const AUTH_STORAGE_KEY = 'auth';

/** Reads and parses the stored session, discarding anything unparseable. */
export const getAuth = () => {
    let raw;
    try {
        raw = localStorage.getItem(AUTH_STORAGE_KEY);
    } catch (error) {
        return null;
    }
    if (!raw) {
        return null;
    }
    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (error) {
        clearAuth();
        return null;
    }
};

export const setAuth = auth => {
    try {
        localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(auth));
    } catch (error) {
        // Nothing useful to do; the session simply will not survive a reload.
    }
};

export const clearAuth = () => {
    try {
        localStorage.removeItem(AUTH_STORAGE_KEY);
    } catch (error) {
        // Ignore.
    }
};

/** The bearer token to send with API calls, or null when not signed in. */
export const getToken = () => {
    const auth = getAuth();
    return auth && typeof auth.token === 'string' && auth.token ? auth.token : null;
};

/**
 * Shape check for a session the app is willing to render with.
 */
export const isAdminSession = auth => {
    if (!auth || typeof auth.token !== 'string' || !auth.token) {
        return false;
    }
    const user = auth.user;
    if (!user || typeof user !== 'object' || user.role !== 'admin') {
        return false;
    }
    return user.status === undefined || user.status === null || user.status === 'active';
};
